module.exports = __webpack_public_path__ + "static/img/docwoman.ee9baa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/docwoman.jpg
// module id = MItN
// module chunks = 1